import * as Sentry from '@sentry/browser';

import { ENV, SENTRY_DSN, VERSION } from './env';

if (SENTRY_DSN) {
  // Initialize the Sentry JavaScript SDK:
  // https://docs.sentry.io/platforms/javascript/
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENV || 'production',
    release: VERSION,
    ignoreErrors: [
      // Ignore axios "low level network errors", e.g. connection failure:
      // https://github.com/axios/axios/blob/v0.19.0/lib/adapters/xhr.js#L81
      'Network Error',
      'Request failed with status code 400',
      'Request failed with status code 401',
      'Request failed with status code 403',
      'Request failed with status code 409',
    ],
  });
}

export default Sentry;
